import Cookies from 'universal-cookie';
import * as CONST from '../ActionTypes';
import * as util from './util';
import { deleteCart } from './cart';

/**
 * 決済
 */
const cookies = new Cookies();
export const getLinkPayment = (accessToken, isLoggedIn, param) => (dispatch) => {
  dispatch(util.loading());
  param.products.forEach((item, index) => {
    if (item.product_id.toLocaleString()
    === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
    || item.product_id.toLocaleString()
    === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
      param.products.splice(index, 1);
      param.products.unshift(item);
    }
  });
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/qrqueries/link?api_key=${process.env.REACT_APP_API_KEY}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((payload) => {
      if (!payload.status) {
        const urlPayment = payload.url;
        dispatch(util.actionType(CONST.PAYMENT_SUCCESS, payload));
        dispatch(util.unLoading());
        dispatch(deleteCart(accessToken, isLoggedIn));
        cookies.remove('salesperson_id');
        if (param.products[0]?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
        || param.products[0]?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
          const url = urlPayment.replace('form.html', 'terra-form.html');
          window.location.href = url;
        } else {
          window.location.href = urlPayment;
        }
      } else {
        dispatch(util.actionType(CONST.PAYMENT_FAILURE, null));
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.PAYMENT_FAILURE, error));
      dispatch(util.unLoading());
    });
};

/**
 *
 */
export const clearResult = () => (dispatch) => {
  dispatch(util.actionType(CONST.CLEAR_PAYMENT_RESULT, null));
};

/**
 *
 */
export const getRuleDiscountById = (accessToken, ruleGroupId) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/public/rule_group/${ruleGroupId}/rule?api_key=fAKhaTA9ecrQNABR2thb&count=1`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((payload) => {
      dispatch(util.actionType(CONST.GET_RULE_DISCOUNT_SUCCESS, payload));
      dispatch(util.unLoading());
    })
    .catch(() => {
      dispatch(util.unLoading());
    });
};
/**
 * カート更新
 */
export const updateCard = (accessToken, param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/sbp/update_card`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((payload) => {
      dispatch(util.actionType(CONST.UPDATE_CARD, payload.masked_card_number));
      return payload.masked_card_number;
    })
    .catch(() => {
      dispatch(util.unLoading());
      return false;
    });
};
